// extracted by mini-css-extract-plugin
export default {"separator":"item_separator-module__separator--1XIUB"};